<script setup>
import { computed } from 'vue'
import formatDate from '@utils/format-date-full'
import MixOptions from '@components/mix/mix-options'

const props = defineProps({
    mix: {
        type: Object,
        default: () => {},
    },
})

const airDate = computed(() => {
    if (props.mix.episode) {
        return formatDate(new Date(props.mix.episode.air_start))
    }
    return ''
})
</script>

<template>
    <div class="mix-grid-tile">
        <BaseLink :to="{ name: 'mix', params: { id: mix.id } }">
            <BaseResourceCover
                :image-resource="mix.episode"
                :media-resource="mix"
                media-type="mix"
                radius="card"
            >
                <template #secondaryActions>
                    <div>
                        <MixOptions :mix="mix" />
                    </div>
                </template>
            </BaseResourceCover>
        </BaseLink>
        <BaseLink
            v-if="mix.artist"
            :to="{ path: `/artist/${mix.artist.url}/${mix.artist.id}` }"
        >
            <div class="title">
                {{ mix.artist.title }}
            </div>
        </BaseLink>
        <BasePlaceholder
            v-else
            class="title"
            :text="mix.artist && mix.artist.title"
            type="artist"
            tag="div"
        />
        <div class="artist">
            <BaseLink
                v-if="mix.show && mix.show.title"
                :to="{ name: 'show', params: { id: mix.show.id } }"
            >
                {{ mix.show.title }}
            </BaseLink>
            <BasePlaceholder
                v-else
                :text="mix.show && mix.show.title"
                type="show"
            />
        </div>
        <div class="date">
            <BaseLink
                v-if="mix.episode"
                :to="{ name: 'mix', params: { id: mix.id } }"
            >
                {{ airDate }}
            </BaseLink>
            <BasePlaceholder
                v-else
                :text="mix.episode && airDate"
                :size="7"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.title {
    @extend %contentTitleM;

    margin-top: $size-grid-padding;
    line-height: 24px;
    text-align: center;
}

.artist {
    @extend %contentSubtitleM;

    text-align: center;

    a {
        color: $c-text-secondary;
    }
}

.date {
    @extend %contentSubtitleS;

    text-align: center;

    a {
        color: $c-text-secondary;
    }
}

// The artist-name link wraps a block div, so the global accent anchor colour only
// surfaced as a pink hover underline under white text (FDS Typography 04: a link's
// line is its own colour). Pin the wrapper to the text it wraps.
.mix-grid-tile > a {
    color: $c-text-primary;
}
</style>
